import { atom } from 'jotai'
import dayjs, { Dayjs } from 'dayjs'
import weekday from 'dayjs/plugin/weekday'

import 'dayjs/locale/pl'

dayjs.extend(weekday)

export type ProtocolFetchRange = {
  startDate: string
  endDate: string
}

/**
 * API fetch window must cover both the selected calendar month (month view /
 * calendar dots) and the visible week (day view). Weeks often spill into the
 * previous/next month; without that expansion those protocols never leave the API.
 */
export const getProtocolFetchRange = (dateInput: string | Dayjs | Date): ProtocolFetchRange => {
  const date = dayjs(dateInput).locale('pl')
  const weekStart = date.weekday(0).startOf('day')
  const weekEnd = date.weekday(6).endOf('day')
  const monthStart = date.startOf('month')
  const monthEnd = date.endOf('month')

  const start = weekStart.isBefore(monthStart, 'day') ? weekStart : monthStart
  const end = weekEnd.isAfter(monthEnd, 'day') ? weekEnd : monthEnd

  return {
    startDate: start.format('YYYY-MM-DD'),
    endDate: end.format('YYYY-MM-DD')
  }
}

export const protocolsDate = atom(new Date().toISOString())
export const leaseDate = atom(getProtocolFetchRange(new Date()))
